import { useQuery } from '@tanstack/react-query';
import { useDareDropApi } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { CHECK_USER_HAS_GAME } from 'root/src/shared/descriptions/endpoints/endpointIds';
export const useUserHasGame = (params, enabled = true) => {
    const { fetcher } = useDareDropApi();
    return useQuery({
        enabled,
        queryKey: ['drop', 'hasGame', params.brandId, params.dropId],
        queryFn: () => fetcher({
            endpointId: CHECK_USER_HAS_GAME,
            payload: {
                brandId: params.brandId, campaignId: params.dropId,
            },
        }),
    });
};
